import { render } from "./HeadLines.vue?vue&type=template&id=565de4ed&scoped=true"
import script from "./HeadLines.vue?vue&type=script&lang=js"
export * from "./HeadLines.vue?vue&type=script&lang=js"

import "./HeadLines.vue?vue&type=style&index=0&id=565de4ed&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-565de4ed"]])

export default __exports__